// extracted by mini-css-extract-plugin
var _1 = "AppointmentFollowUpModal-modulelines__dG65k";
export { _1 as "lines" }
